"use client";
import CountryCodeField from "@/components/common/formElements/controlled/CountryCodeField";
import { type FormFieldProps } from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/types";
import { useCustomFormFieldProps } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormFieldProps";

export default function CustomCountryCodeField(props: FormFieldProps) {
  const { field } = props;

  const { fieldName, fieldLabel, fieldPlaceholder, fieldRules } =
    useCustomFormFieldProps(field);

  return (
    <CountryCodeField
      name={fieldName}
      label={fieldLabel}
      placeholder={fieldPlaceholder}
      rules={fieldRules}
      tooltip={field.toolTipText}
    />
  );
}
